import { AgxColumn, AgxTypography } from '@urbanx/agx.ui-components2';

import './SupportPage.scss';
import { Outlet } from 'react-router-dom';

const SupportPage = () => {
  return (
    <div className="supportPage">
      <AgxColumn gap={'spacing-2xl'} fill padding="spacing-4xl">
        <AgxTypography id={'supportToolsHeading'} type={'heading'} size={'large'}>
          Support Tools
        </AgxTypography>

        <AgxTypography id="supportToolsDescription" type={'body'} size={'medium'}>
          This is a Support Page to assist staff with managing Autopilot incidents. Only Super Admin
          and Executive users can access this page.
        </AgxTypography>

        <Outlet />
      </AgxColumn>
    </div>
  );
};

export default SupportPage;
